import './_styles.scss';
import React from 'react';

import {
  IoMdCheckbox as Checked,
  IoMdSquareOutline as NotChecked
} from 'react-icons/io';

export default ({ name, value, caption, onSelect }) => {

  const Icon = (!value) ? NotChecked : Checked;

  return (
    <label className='Radio noselect' htmlFor={name}>

      <input
        id={name}
        name={name}
        type="radio"
        checked={value}
        onChange={onSelect}
      />

      <Icon className='Icon'/>

      <span
        className='Label'
        dangerouslySetInnerHTML={{ __html: caption }}
      />

    </label>
  )
}
